import * as api from '@eventManager/api';
import * as MutationTypes from '../mutationTypes';
import { EventType } from '../models';

export const eventTypeListRequest = async ({ commit }) => {
  const response = await api.eventTypeListRequest();
  const eventTypeList = EventType.toInstanceList(response.data.results);
  commit(MutationTypes.EVENT_TYPE_LIST_SUCCESS, eventTypeList);
};

export const createEventTypeRequest = async ({ commit }, eventType) => {
  const serializedEventType = eventType.serialize();
  const response = await api.createEventTypeRequest(serializedEventType);
  const newEventType = EventType.toInstance(response.data);
  commit(MutationTypes.CREATE_EVENT_TYPE_SUCCESS, newEventType);
};

export const updateEventTypeRequest = async ({ commit }, eventType) => {
  const serializedEventType = eventType.serialize();
  const { guid } = serializedEventType;
  delete serializedEventType.guid;
  const response = await api.updateEventTypeRequest(guid, serializedEventType);
  const newEventType = EventType.toInstance(response.data);
  commit(MutationTypes.UPDATE_EVENT_TYPE_SUCCESS, newEventType);
};

export const deleteEventTypeRequest = async ({ commit }, eventType) => {
  await api.deleteEventTypeRequest(eventType.guid);
  commit(MutationTypes.DELETE_EVENT_TYPE_SUCCESS, eventType);
};
